import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Compass from './index';

const Routes = () => (
  <Switch>
    <Route exact path="/compass" component={Compass} />
  </Switch>
);

export default Routes;
